module.exports = __webpack_public_path__ + "img/icon-warning-red.c1a9a9d0.svg";